export const nonSettingsPageNavigationEntryPredicate = (pathname: string) => !pathname.startsWith("/settings");
